import { defineStore } from "pinia";
import apiClient from "@/apiClient";

export const useVacancyStore = defineStore("vacancy", {
  state: () => ({
    newCount: null,
    newCountLoaded: false,
    newCountLoading: false,
  }),

  actions: {
    async fetchNewCount({ force = false } = {}) {
      if (this.newCountLoading) {
        return this.newCount;
      }

      if (this.newCountLoaded && !force) {
        return this.newCount;
      }

      this.newCountLoading = true;

      try {
        const { data } = await apiClient.get("/api/vacancy/counters");
        this.newCount = Number(data?.new ?? 0);
        this.newCountLoaded = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.newCountLoading = false;
      }

      return this.newCount;
    },

    setNewCount(count) {
      this.newCount = Number(count ?? 0);
      this.newCountLoaded = true;
    },
  },
});
